/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percent (w/v) Solution Calculator — Toolverse`)
};

const es_pctsol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Solución Porcentual (p/v) — Toolverse`)
};

const de_pctsol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozent-(w/v)-Lösungsrechner — Toolverse`)
};

const nl_pctsol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procentuele (g/v) oplossingscalculator — Toolverse`)
};

const fr_pctsol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de solution en pourcentage (p/v) — Toolverse`)
};

const it_pctsol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di soluzioni percentuali (p/v) — Toolverse`)
};

const pt_br2_pctsol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Solução Percentual (p/v) — Toolverse`)
};

const pt_pctsol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Solução Percentual (m/v) — Toolverse`)
};

const ja_pctsol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント (w/v) 溶液計算ツール — Toolverse`)
};

const zh_pctsol_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比（w/v）溶液计算器 — Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_meta_title", locale)
	if (locale === "en") return en_pctsol_meta_title(inputs)
	if (locale === "es") return es_pctsol_meta_title(inputs)
	if (locale === "de") return de_pctsol_meta_title(inputs)
	if (locale === "nl") return nl_pctsol_meta_title(inputs)
	if (locale === "fr") return fr_pctsol_meta_title(inputs)
	if (locale === "it") return it_pctsol_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_meta_title(inputs)
	if (locale === "pt") return pt_pctsol_meta_title(inputs)
	if (locale === "ja") return ja_pctsol_meta_title(inputs)
	return zh_pctsol_meta_title(inputs)
};